// 统一数据接口层:全部对接后端真实接口(/api 前缀由 devServer 代理转发)
// 除登录接口外,请求头由 request.js 自动注入 Authorization: Bearer {token}
import request from './request'

// ---------- 用户管理与登录(后端 t-user,写操作仅管理员) ----------
export const userApi = {
  // 登录:account 支持用户名或邮箱,成功返回 { token, user },此接口免 token
  login: data => request.post('/user/login', data),

  // 当前登录用户信息
  me: () => request.get('/user/me'),

  // 分页查询用户列表(仅管理员)
  page: params => request.get('/user/page', { params }),

  // 新增用户(仅管理员)
  add: data => request.post('/user', data),

  // 修改用户(仅管理员,password 留空表示不变更)
  update: data => request.put('/user', data),

  // 删除用户(仅管理员)
  remove: id => request.delete(`/user/${id}`)
}

// ---------- 14 个业务模块通用 CRUD ----------
// key 与后端 Controller 的 @RequestMapping 一致(/farm、/feed、/check ...),
// 接口形态统一为 GET /{key}/page、GET /{key}/{id}、POST /{key}、PUT /{key}、DELETE /{key}/{id}
function createModuleApi(key) {
  return {
    page: params => request.get(`/${key}/page`, { params }),
    detail: id => request.get(`/${key}/${id}`),
    add: data => request.post(`/${key}`, data),
    update: data => request.put(`/${key}`, data),
    remove: id => request.delete(`/${key}/${id}`)
  }
}

// 同一模块只创建一次,避免每次调用生成新对象
const moduleApiCache = {}

export function moduleApi(key) {
  if (!moduleApiCache[key]) {
    moduleApiCache[key] = createModuleApi(key)
  }
  return moduleApiCache[key]
}

// ---------- 统计报表(10 张,登录即可访问) ----------
// reportKey 取自路由末段:sales/stock/io/finance/disease/production/business/health/yield/marketing
export function getReport(reportKey) {
  return request.get(`/report/${reportKey}`)
}
